import {
  importOrdersConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { withSpinner } from "../../../../redux/actions/utilities";
import { globalService } from "../../services";

const { IMPORT_ORDER_DATA, IMPORT_ORDER_SUCESSFULLY } = importOrdersConstants;

const importOrdersFromFR = () => {
  return (dispatch) => {
    withSpinner(dispatch, IMPORT_ORDER_DATA, () =>
      globalService
        .importOrdersFromFR()
        .then(
          (_response) => {
            customToast(IMPORT_ORDER_SUCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const globalActions = {
  importOrdersFromFR,
};
